// removed by extract-text-webpack-plugin
module.exports = {"section":"newestItemSection-module_section_12kBI","loading":"newestItemSection-module_loading_2uP5M","heading":"newestItemSection-module_heading_1FAwv","categoriesListDesktop":"newestItemSection-module_categoriesListDesktop_3Qrra","categoriesListMobile":"newestItemSection-module_categoriesListMobile_1RxkP","select":"newestItemSection-module_select_2SENN","categoryLink":"newestItemSection-module_categoryLink_K_8iZ","activeCategoryLink":"newestItemSection-module_activeCategoryLink_3ekrL"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/newestItemSection/newestItemSection.module.css
// module id = 481
// module chunks = 1 3